<template>
  <nav v-if="!loadingData">
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="11" class="mx-auto px-0">
        <v-row
          v-if="Object.keys(storeProduct).length > 0"
          class="fill-height"
          justify="center"
        >
          <v-col cols="12" md="5">
            <v-img
              class="rounded-xxl mt-14"
              :src="storeProduct.attributes.image"
              max-height="400"
            ></v-img>
          </v-col>
          <v-col cols="12" md="5" offset-md="1">
            <v-img
              v-if="logo == null"
              data-testid="logo-space"
              src="../../assets/rtplogo.svg"
              height="40"
              max-width="150"
              width="auto"
              class="d-none d-sm-block justify-center mb-4 default"
              contain
            />
            <v-img
              v-else
              data-testid="logo-space"
              :src="logo"
              height="40"
              max-width="150"
              width="auto"
              class="d-none d-sm-block justify-center mb-4"
              position="top left"
              contain
            />
            <p class="text-h4 mb-10">{{ storeProduct.attributes.title }}</p>
            <p
              class="mb-10 grey--text content-block"
              v-html="storeProduct.attributes.description"
            ></p>
            <p class="mb-0" data-testid="product-price">
              {{ $t("storeOrderPricePerPerson")
              }}<span class="d-block font-weight-bold"
                >{{ storeProduct.attributes.currency.code }} {{ price }}</span
              >
            </p>

            <br />
            <br />
            <v-btn
              v-if="storeProduct.attributes.session_type == 'single'"
              :disabled="
                registerDisabled ||
                storeProduct.attributes.participants_seats_left === 0 ||
                closeProductDate()
              "
              class="rounded-xxl text-none white--text"
              color="darktext"
              :dark="
                !registerDisabled &&
                storeProduct.attributes.participants_seats_left > 0
              "
              @click="redirectToRegisterProduct"
              data-testid="register-btn"
              >{{ closeProductDate() ? $t("closed") : $t("register") }}</v-btn
            >

            <v-btn
              v-if="
                storeProduct.attributes.session_type == 'multiple' &&
                sessions.length == 1
              "
              :disabled="
                sessions[0].attributes.participants_seats_left === 0 ||
                closeSessionDate(sessions[0])
              "
              class="rounded-xxl text-none white--text"
              color="darktext"
              :dark="sessions[0].attributes.participants_seats_left > 0"
              @click="redirectToRegisterProductSession(sessions[0].id)"
              >{{
                closeSessionDate(sessions[0]) ? $t("closed") : $t("register")
              }}</v-btn
            >
            <br />
            <br />
            <p
              v-if="storeProduct.attributes.participants_seats_left !== null && !closeProductDate()"
              data-testid="product-available-seats"
              class="success--text"
            >
              {{ $t("storeOrderAvailableSeats") }}: {{ storeProduct.attributes.participants_seats_left }}
            </p>

            <p
              v-if="
                storeProduct.attributes.session_type == 'multiple' &&
                sessions.length == 1 &&
                sessions[0].attributes.end_date
              "
              data-testid="product-end_date"
              class="success--text"
            >
              {{ $t("sessionEndDate") }}:
              {{ format_date(sessions[0].attributes.end_date) }}
            </p>
            <p
              v-if="
                storeProduct.attributes.session_type == 'single' &&
                storeProduct.attributes.end_date && !closeProductDate()
              "
              data-testid="product-end_date"
              class="success--text"
            >
              {{ $t("sessionEndDate") }}:
              {{ format_date(storeProduct.attributes.end_date) }}
            </p>
          </v-col>

          <v-col
            cols="12"
            md="8"
            class="mt-10"
            v-if="
              storeProduct.attributes.session_type == 'multiple' &&
              sessions.length > 1
            "
          >
            <h3 class="text-center" data-testid="product-session-heading">
              {{ $t("sessions") }}
            </h3>
            <v-row
              v-for="session in sessions"
              :key="session.id"
              class="session-row"
            >
              <v-col cols="4" class="align-center d-flex">
                {{ session.attributes.session_title }}
              </v-col>
              <v-col cols="6" class="align-center d-flex">
                <v-card-text
                  v-if="session.attributes.participants_seats_left !== null"
                  :color="'success'"
                  class="success--text"
                  >{{ $t("availableSeats") }}:
                  {{ session.attributes.participants_seats_left }}</v-card-text
                >
                <v-card-text v-else>&nbsp;</v-card-text>

                <v-card-text
                  v-if="session.attributes.end_date !== null"
                  :color="'success'"
                  class="success--text"
                  >{{ $t("sessionEndDate") }}:
                  {{ format_date(session.attributes.end_date) }}</v-card-text
                >
              </v-col>
              <v-col cols="2" class="text-center align-center d-flex">
                <v-btn
                  class="rounded-xxl text-none white--text"
                  color="darktext"
                  :disabled="
                    session.attributes.participants_seats_left === 0 ||
                    closeSessionDate(session)
                  "
                  :dark="session.attributes.participants_seats_left > 0"
                  @click="redirectToRegisterProductSession(session.id)"
                  >{{
                    closeSessionDate(session) ? $t("closed") : $t("register")
                  }}</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import {
  getStoreProductPublic,
  getProductSessions,
} from "../../api/productApi";
import AlertMessages from "../../components/AlertMessages";
import i18n from "../../plugins/i18n";
import moment from "moment";
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";

export default {
  components: {
    AlertMessages,
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      alertType: "",
      alertMsg: "",
      alertValue: false,
      spaceId: window.$cookies.get("space_id"),
      loadingData: false,
      storeProduct: {},
      productID: this.$route.params.id,
      space: window.location.host.split(".")[0],
      registerDisabled: true,
      price: 0,
      logo: localStorage.space ? JSON.parse(localStorage.space).logo : null,
      sessions: [],
    };
  },
  async created() {
    this.loadingData = true;
    await this.fetchStoreProduct();
    this.loadingData = false;
    i18n.locale = window.$cookies.get('language') ? window.$cookies.get('language') : window.$cookies.get('space_language') ? window.$cookies.get('space_language') : 'sv';
  },
  methods: {
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD MMM YYYY");
      }
    },
    closeSessionDate(session) {
      const endDate = moment(session.attributes.end_date);
      const today = moment().startOf("day");

      if (endDate.isBefore(today, "day")) {
        return true;
      }
      return false;
    },

    closeProductDate() {
      const endDate = moment(this.storeProduct.attributes.end_date);
      const today = moment().startOf("day");

      if (endDate.isBefore(today, "day")) {
        return true;
      }
      return false;
    },
    async fetchStoreProduct() {
      try {
        const response = await getStoreProductPublic(this.productID);
        if (response.status == 200) {
          this.storeProduct = response.data.data;
          this.price = this.storeProduct.attributes.price
            .toLocaleString("id-ID", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
              useGrouping: true,
              style: "decimal",
            })
            .replace(",", ".");
          this.registerDisabled = false;
          if (this.storeProduct.attributes.session_type == "multiple") {
            await this.fetchSessions();
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: "PageNotFound" });
          } else if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },
    redirectToRegisterProduct() {
      this.$router.push({
        name: "RegisterProductPublic",
        params: { id: this.productID },
      });
    },
    redirectToRegisterProductSession(sessionId) {
      this.$router.push({
        name: "RegisterProductPublic",
        params: { id: this.productID },
        query: { session_id: sessionId },
      });
    },

    async fetchSessions() {
      const response = await getProductSessions(this.storeProduct.id);
      if (response.status == 200) {
        this.sessions = response.data.data;
      }
    },
  },
};
</script>
<style scoped>
.session-row {
  border-bottom: 1px solid #ccc;
}
.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: rgb(0 0 0 / 12%) !important;
}
.theme--dark.v-btn.v-btn--disabled {
  color: #000 !important;
}
</style>